import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PieController,
  PointElement,
  RadarController,
  RadialLinearScale,
  Title,
  Tooltip
} from 'chart.js';
import {Chart as ReactChartJS} from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ArcElement,
  LineController,
  PieController,
  RadialLinearScale,
  RadarController
);
ChartJS.defaults.font.family = 'IRANSans';

type ChartProps = {
  config: Record<string, unknown>;
};

const Chart = ({config}: ChartProps) => {
  return <ReactChartJS {...(config as unknown as React.ComponentProps<typeof ReactChartJS>)} />;
};

export default Chart;
